// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export enum ApiCommunityMembersSortOption {
    Display = 'display',
    Level = 'level',
    Tdh = 'tdh',
    TdhRate = 'tdh_rate',
    Rep = 'rep',
    Cic = 'cic',
    Xtdh = 'xtdh',
    XtdhRate = 'xtdh_rate',
    XtdhOutgoing = 'xtdh_outgoing',
    XtdhIncoming = 'xtdh_incoming',
    CombinedTdh = 'combined_tdh',
    CombinedTdhRate = 'combined_tdh_rate'
}
